import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { SkillService } from '../../../../skill/services/skill.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-revocation-dialog',
  templateUrl: './revocation-dialog.component.html',
  styleUrls: ['./revocation-dialog.component.scss']
})
export class RevocationDialogComponent implements OnInit {
  @Input() display: boolean = false;
  @Input() skillCode: string = '';
  @Input() skillName: string = '';
  @Output() onConfirm = new EventEmitter<{ itemIds: string[]; reason: string; nonCompleteItems: any[] }>();
  @Output() onCancel = new EventEmitter<void>();

  trainingItems: any[] = [];
  selectedItemIds: string[] = [];
  removalReason: string = '';
  isLoading: boolean = false;
  errorMessages: string[] = [];
  mandatoryFields = {
    selectedItems: false,
    removalReason: false
  };

  constructor(
    private skillService: SkillService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    }
  

  ngOnChanges(): void {
    // Load training items when dialog opens
    if (this.display && this.skillCode && this.trainingItems.length === 0) {
      this.loadTrainingItems();
    }
  }

  loadTrainingItems(): void {
    this.isLoading = true;
    this.errorMessages = [];

    this.skillService.getLinkedTrainingItems(this.skillCode).subscribe({
      next: (items: any[]) => {
        // Filter to show only active items (status = 1)
        this.trainingItems = (items || []).filter(item => item.status === 1);
        this.isLoading = false;
        // Don't show error message if empty - keep dialog empty as requested
      },
      error: (error: any) => {
        console.error('Error loading training items:', error);
        this.trainingItems = [];
        this.errorMessages = [
          'Failed to load training items. Please try again.'
        ];
        this.isLoading = false;
      }
    });
  }

  saveRevocation(): void {
    this.errorMessages = [];
    this.validateControls();

    if (this.errorMessages.length === 0) {
      this.onConfirm.emit({
        itemIds: this.selectedItemIds,
        reason: this.removalReason,
        nonCompleteItems: []
      });
      this.resetDialog();
    }
  }

  private validateControls(): void {
    // Validate at least one item is selected
    if (!this.selectedItemIds || this.selectedItemIds.length === 0) {
      this.mandatoryFields.selectedItems = true;
      this.errorMessages.push('Select at least one training item to revoke.');
    } else {
      this.mandatoryFields.selectedItems = false;
    }

    // Validate reason
    const isWhitespace = (this.removalReason || '').trim().length === 0;

    if (
      this.removalReason === '' ||
      this.removalReason === undefined ||
      isWhitespace
    ) {
      this.mandatoryFields.removalReason = true;
      this.errorMessages.push('Revocation reason is required.');
    } else {
      this.mandatoryFields.removalReason = false;
    }
  }

  cancel(): void {
    this.resetDialog();
    this.onCancel.emit();
  }

  private resetDialog(): void {
    this.selectedItemIds = [];
    this.removalReason = '';
    this.errorMessages = [];
    this.mandatoryFields.selectedItems = false;
    this.mandatoryFields.removalReason = false;
    this.trainingItems = [];
  }
}
